import Quotes from './components/Quotes.vue'

export const routes = [
  {
    path: '/',
    component: Quotes
  }
];
